import { Card } from "@/shared/components/ui/card"

export function AvisoLegalPage() {
  return (
    <div className="pt-32 pb-20 lg:pt-40 lg:pb-32">
      <div className="container mx-auto px-4 lg:px-8 max-w-8xl">
        <h1 className="text-4xl lg:text-6xl font-bold mb-8">Aviso Legal</h1>

        <Card className="p-8 lg:p-12 space-y-8">
          <section className="space-y-4">
            <h2 className="text-2xl font-bold">Datos Identificativos</h2>
            <p className="text-xl-foreground leading-relaxed">
              Razón Social: Valerosas Tech S.A.S
              <br />
              Nombre Comercial: Rapyfact
              <br />
              Dirección: Carrera 92 N 8a 76, Bogotá - Colombia
              <br />
              Email: soporte@rapyfact.com
              <br />
              Teléfono: +57 3135909091
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">Objeto</h2>
            <p className="text-xl-foreground leading-relaxed">
              Rapyfact es una plataforma de facturación electrónica especializada en el sector salud colombiano, que
              proporciona servicios de validación RIPS, almacenamiento seguro y cumplimiento normativo.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">Propiedad Intelectual</h2>
            <p className="text-xl-foreground leading-relaxed">
              Todos los contenidos, diseños, logotipos y software de este sitio web son propiedad de Valerosas Tech
              S.A.S y están protegidos por las leyes de propiedad intelectual colombianas e internacionales.
            </p>
          </section>
        </Card>
      </div>
    </div>
  )
}
